import React from "react";

const BranchContactInfo = ({ formData, updateField, errors }) => {
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Primary Phone *
          </label>
          <input
            type="tel"
            value={formData.contact.phoneNumber}
            onChange={(e) =>
              updateField("contact", "phoneNumber", e.target.value)
            }
            maxLength="10"
            className={`w-full px-3 py-2 border rounded-lg ${
              errors.phoneNumber ? "border-red-500" : "border-gray-300"
            }`}
          />
          {errors.phoneNumber && (
            <p className="text-red-500 text-xs mt-1">{errors.phoneNumber}</p>
          )}
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Alternate Phone
          </label>
          <input
            type="tel"
            value={formData.contact.alternatePhone}
            onChange={(e) =>
              updateField("contact", "alternatePhone", e.target.value)
            }
            maxLength="10"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            WhatsApp Number
          </label>
          <input
            type="tel"
            value={formData.contact.whatsappNumber}
            onChange={(e) =>
              updateField("contact", "whatsappNumber", e.target.value)
            }
            maxLength="10"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Email
          </label>
          <input
            type="email"
            value={formData.contact.email}
            onChange={(e) => updateField("contact", "email", e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Manager Name
          </label>
          <input
            type="text"
            value={formData.contact.managerName}
            onChange={(e) =>
              updateField("contact", "managerName", e.target.value)
            }
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Manager Phone
          </label>
          <input
            type="tel"
            value={formData.contact.managerPhone}
            onChange={(e) =>
              updateField("contact", "managerPhone", e.target.value)
            }
            maxLength="10"
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">
            Manager Email
          </label>
          <input
            type="email"
            value={formData.contact.managerEmail}
            onChange={(e) =>
              updateField("contact", "managerEmail", e.target.value)
            }
            className="w-full px-3 py-2 border border-gray-300 rounded-lg"
          />
        </div>
      </div>
    </div>
  );
};

export default BranchContactInfo;
